import { RiCustomerServiceFill } from 'react-icons/ri'; //atendimento
import { BiSolidReport } from 'react-icons/bi'; //relatorio
import { SiOnlyoffice } from 'react-icons/si'; //monitoria
import { SlHome } from 'react-icons/sl'; //home
import { AiFillControl } from 'react-icons/ai'; //backoffice
import { MdOutlineAssignmentInd } from 'react-icons/md'; //suport
import { IconType } from 'react-icons/lib';
import { IoSearch } from 'react-icons/io5';
// import atendimentoIcon from '../../../assets/sidebar/atendimento.svg'
// import supervisaoIcon from '../../../assets/sidebar/supervisao.svg'
// import backofficeIcon from '../../../assets/sidebar/backoffice.svg'
// import monitoriaIcon from '../../../assets/sidebar/atendimento.svg'

export interface MenuProps {
  name: string;
  link: string;
  perfils?: number[];
}

export interface BarIconsProps {
  link?: string;
  name: string;
  Icon: IconType;
  menu?: MenuProps[];
  perfils?: number[];
}

export const barIcons: BarIconsProps[] = [
  {
    link: '/home',
    name: 'Home',
    Icon: SlHome,
  },
  {
    link: '/consulta',
    name: 'Consulta',
    Icon: IoSearch,
  },
  {
    name: 'Atendimento',
    Icon: RiCustomerServiceFill,
    menu: [
      {
        name: 'Hibrido',
        link: '/hibrido',
        perfils: [2, 3],
      },
      {
        name: 'Transbordo',
        link: '/home',
      },
      {
        name: 'Callback',
        link: '/callback',
        perfils: [2, 3],
      },
      {
        name: 'Operador Loja',
        link: '/operador',
        perfils: [2],
      },
      {
        name: 'Operador Caixa',
        link: '/operador-caixa',
        perfils: [9],
      },
      {
        name: 'Operador Loja - WhatsApp',
        link: '/operador-loja-whats',
        perfils: [2],
      },
      {
        name: 'Portfólio Fidelizado',
        link: '/home',
      },
      {
        name: 'Análise Contra Proposta',
        link: '/analise-contra-proposta',
      },
    ],
    perfils: [2, 9, 3],
  },
  {
    name: 'Monitoria',
    Icon: SiOnlyoffice,
    menu: [
      {
        name: 'Formulário de Monitoria',
        link: '',
      },
      {
        name: 'Book de Monitoria',
        link: '',
      },
    ],
    perfils: [6, 3],
  },
  {
    name: 'BackOffice',
    Icon: AiFillControl,
    menu: [
      {
        name: 'Controle de Envio de Acordos',
        link: '',
      },
      {
        name: 'Controle de 2ª Via de Acordo',
        link: '',
      },
      {
        name: 'Controle de Negociações WEB',
        link: '',
      },
      {
        name: 'Manutenção de Propostas',
        link: '',
      },
      {
        name: 'Gestão de Parcelamento',
        link: '',
      },
      {
        name: 'Prestação de Contas',
        link: '',
      },
      {
        name: 'Quebra de Acordo/Parcelamento',
        link: '',
      },
      {
        name: 'Controle de Fraude',
        link: '',
      },
    ],
    perfils: [5, 3],
  },
  {
    name: 'Suporte',
    Icon: MdOutlineAssignmentInd,
    menu: [
      {
        name: 'Cadastro de Usuário',
        link: '/suporte/usuario',
      },
      {
        name: 'Criar Grupo de Usuarios',
        link: '',
      },
      {
        name: 'Listar Grupo de Usuarios',
        link: '',
      },
      {
        name: 'Criar Filas',
        link: '',
      },
      {
        name: 'Visualizar Filas',
        link: '',
      },
      {
        name: 'Direcionar Filas',
        link: '',
      },
    ],
    perfils: [4],
  },
  {
    name: 'Supervisão',
    Icon: BiSolidReport,
    menu: [
      {
        name: 'Arrecadação',
        link: '',
      },
      {
        name: 'Estratificação de Base',
        link: '',
      },
      {
        name: 'Ranking Operadores',
        link: '',
      },
      {
        name: 'Painel Produtividade',
        link: '',
      },
    ],
    perfils: [3],
  },
];
